import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  DefaultAccountSliceType,
  DefaultPaymentMethodType,
} from "types/defaultAccount";

const initialState: DefaultAccountSliceType = {
  defaultAccount: null,
};

export const defaultAccountSlice = createSlice({
  name: "defaultAccount",
  initialState,
  reducers: {
    setDefaultAccount: (
      state: DefaultAccountSliceType,
      action: PayloadAction<DefaultPaymentMethodType>
    ) => {
      state.defaultAccount = action.payload;
    },
  },
});

export const { setDefaultAccount } = defaultAccountSlice.actions;
export default defaultAccountSlice.reducer;
